import TempleHinduIcon from '@mui/icons-material/TempleHindu';
import TerrainIcon from '@mui/icons-material/Terrain';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import ForestIcon from '@mui/icons-material/Forest';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import LandscapeIcon from '@mui/icons-material/Landscape';
import ParkIcon from '@mui/icons-material/Park';
import WaterIcon from '@mui/icons-material/Water';
import ExploreIcon from '@mui/icons-material/Explore';
import PublicIcon from '@mui/icons-material/Public';
import HubIcon from '@mui/icons-material/Hub';
import FlagIcon from '@mui/icons-material/Flag';
import FortIcon from '@mui/icons-material/Fort';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';
import CabinIcon from '@mui/icons-material/Cabin';
import SailingIcon from '@mui/icons-material/Sailing';
import MapIcon from '@mui/icons-material/Map';
import AttractionsIcon from '@mui/icons-material/Attractions';
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';
import LandscapeOutlinedIcon from '@mui/icons-material/LandscapeOutlined';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import TerrainOutlinedIcon from '@mui/icons-material/TerrainOutlined';

export const states = [
  { key: 'all', label: 'All India', icon: PublicIcon },
  { key: 'andhra-pradesh', label: 'Andhra', icon: TempleHinduIcon },
  { key: 'arunachal-pradesh', label: 'Arunachal', icon: TerrainIcon },
  { key: 'assam', label: 'Assam', icon: WaterIcon },
  { key: 'bihar', label: 'Bihar', icon: AccountBalanceIcon },
  { key: 'chhattisgarh', label: 'Chhattisgarh', icon: ForestIcon },
  { key: 'goa', label: 'Goa', icon: BeachAccessIcon },
  { key: 'gujarat', label: 'Gujarat', icon: FortIcon },
  { key: 'haryana', label: 'Haryana', icon: HolidayVillageIcon },
  { key: 'himachal-pradesh', label: 'Himachal', icon: LandscapeIcon },
  { key: 'jharkhand', label: 'Jharkhand', icon: ParkIcon },
  { key: 'karnataka', label: 'Karnataka', icon: AttractionsIcon },
  { key: 'kerala', label: 'Kerala', icon: DirectionsBoatIcon },
  { key: 'madhya-pradesh', label: 'MP', icon: NaturePeopleIcon },
  { key: 'maharashtra', label: 'Maharashtra', icon: LocationCityIcon },
  { key: 'manipur', label: 'Manipur', icon: EmojiNatureIcon },
  { key: 'meghalaya', label: 'Meghalaya', icon: CabinIcon },
  { key: 'mizoram', label: 'Mizoram', icon: LocalFloristIcon },
  { key: 'nagaland', label: 'Nagaland', icon: FlagIcon },
  { key: 'odisha', label: 'Odisha', icon: SailingIcon },
  { key: 'punjab', label: 'Punjab', icon: HubIcon },
  { key: 'rajasthan', label: 'Rajasthan', icon: WbSunnyIcon },
  { key: 'sikkim', label: 'Sikkim', icon: LandscapeOutlinedIcon },
  { key: 'tamil-nadu', label: 'Tamil Nadu', icon: TempleHinduIcon },
  { key: 'telangana', label: 'Telangana', icon: MapIcon },
  { key: 'tripura', label: 'Tripura', icon: PublicIcon },
  { key: 'uttar-pradesh', label: 'UP', icon: ExploreIcon },
  { key: 'uttarakhand', label: 'Uttarakhand', icon: TerrainOutlinedIcon },
  { key: 'west-bengal', label: 'WB', icon: TravelExploreIcon },
];
